<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_ProfitShareAdjust')"
    width="1020px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    custom-class="details-view profit-share-dialog"
  >
    <div class="main-content">
      <el-form
        :inline="true"
        :model="shareAmount"
        label-width="100px"
        label-position="right"
      >
        <div class="el-form-item-wrapper" style="padding-top: 5px">
          <el-form-item :label="$t('CargoMsg.Cargo_UsdProfit')">
            <el-input-number v-model="shareAmount.usdProfitSum" no="usdProfitSum" :disabled="true" :precision="2" :controls="false" /> USD
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_NonUsdProfit')">
            <el-input-number v-model="shareAmount.nonUsdProfitSum" no="nonUsdProfitSum" :disabled="true" :precision="2" :controls="false" /> {{ localCurrency }}
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_JobProfit')">
            <el-input-number v-model="shareAmount.jobProfitSum" no="jobProfitSum" :disabled="true" :precision="2" :controls="false" /> {{ localCurrency }}
          </el-form-item>
        </div>
        <div class="el-form-item-wrapper" style="padding-top: 5px;padding-bottom: 5px">
          <el-form-item :label="$t('CargoMsg.Cargo_ShareMode')">
            <el-select v-model="shareAmount.shareMode" no="shareMode" style="width:130px" :disabled="true" @change="changeShareAmount()">
              <el-option :label="$t('CargoMsg.Cargo_ShareModeJob')" value="job" />
              <el-option :label="$t('CargoMsg.Cargo_ShareModeCurrency')" value="currency" />
            </el-select>
          </el-form-item>
        </div>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="shareAmounts"
            :auto-fit-content="false"
            style="width: 100%;"
            min-height="140px"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
        <div class="el-form-item-wrapper" style="padding-top: 10px;padding-bottom: 5px;border-top: 1px solid #000000;">
          <el-form-item :label="$t('CargoMsg.Cargo_UsdProfit')+$t('CargoMsg.Cargo_AdjustColumn')">
            <el-input-number v-model="shareAmount.usdProfitAdjust" no="usdProfitAdjust" :disabled="true" :precision="2" :controls="false" /> USD
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_NonUsdProfit')+$t('CargoMsg.Cargo_AdjustColumn')">
            <el-input-number v-model="shareAmount.nonUsdProfitAdjust" no="nonUsdProfitAdjust" :disabled="true" :precision="2" :controls="false" /> {{ localCurrency }}
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_JobProfit')+$t('CargoMsg.Cargo_AdjustColumn')">
            <el-input-number v-model="shareAmount.jobProfitAdjust" no="jobProfitAdjust" :disabled="true" :precision="2" :controls="false" /> {{ localCurrency }}
          </el-form-item>
        </div>
        <div class="section grid-wrapper">
          <cargo-ag-grid
            :grid-options="gridOptions"
            :column-defs="columnDefsAdjust"
            :row-data="shareBranchList"
            :auto-fit-content="false"
            style="width: 100%;"
            min-height="140px"
            @gridReady="params=>{gridApiJob=params.api}"
          />
        </div>
      </el-form>
    </div>
    <div slot="footer" style="float: right">
      <el-button type="primary" no="confirm" @click="onConfirm">{{ $t('CargoMsg.Cargo_ConfirmR') }}</el-button>
      <el-button no="cancel" @click="onCancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import CargoAgGrid from '@/components/Cargo/Common/cargoAgGrid'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as NumberUtils from '@/utils/NumberUtils'
import lodash from 'lodash'

export default {
  name: 'ProfitShareAdjustDialog',
  components: { CargoAgGrid, CargoAgGridCommonInputEditor },
  props: {
    visible: { type: Boolean, required: true, default: () => false },
    jobUuid: { type: String, required: true },
    job: { type: Object, required: true },
    shareAmount: { type: Object }, // 分润记录
    shareAmounts: { type: Array }, // 分润记录列表
    initShareAmount: { type: Object }, // 最新分润金额
    shareBranchList: { type: Array } // 参与分润分公司
  },
  data() {
    return {
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [],
          resizable: true,
          filter: true
        },
        frameworkComponents: {
          CargoAgGridCommonInputEditor
        },
        pagination: false
      },
      gridParams: {},
      rowData: [],
      gridApi: null,
      gridApiJob: null,
      innerVisible: false
    }
  },
  computed: {
    // 是否显示非美金
    showNonUsdRatioInput() {
      return this.shareAmount.shareMode !== SystemConstants.SHARE_MODE_JOB.code
    },
    columnDefs() {
      return [
        { headerName: this.$t('CargoMsg.Cargo_SerialNo'), colId: 'serialNo', field: 'serialNo', initialWidth: 50, minWidth: 50, sortable: false, editable: false,
          cellStyle: { textAlign: 'center' }
        },
        { headerName: this.$t('CargoMsg.Cargo_ShareBranchId'), colId: 'branchId', field: 'branchId', initialWidth: 160, minWidth: 160, sortable: false, editable: false,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          }
        },
        { headerName: (this.showNonUsdRatioInput ? this.$t('CargoMsg.Cargo_UsdRatioColumn') : this.$t('CargoMsg.Cargo_UsdRatio')) + '-%', colId: 'usdRatio', field: 'usdRatio', initialWidth: 140, minWidth: 140, sortable: false, editable: false,
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0')
          },
          cellStyle: { textAlign: 'center' }
        },
        { headerName: (this.showNonUsdRatioInput ? this.$t('CargoMsg.Cargo_UsdProfitColumn') + '-USD' : this.$t('CargoMsg.Cargo_UsdProfitColumn2') + '-' + this.localCurrency), colId: 'usdProfitCol', field: 'usdProfitCol', initialWidth: 140, minWidth: 140, sortable: false, editable: false,
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          },
          cellStyle: { textAlign: 'center' }
        },
        { headerName: this.$t('CargoMsg.Cargo_NonUsdRatioColumn') + '-%', colId: 'nonUsdRatio', field: 'nonUsdRatio', initialWidth: 140, minWidth: 140, sortable: false, editable: false,
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0')
          },
          cellStyle: { textAlign: 'center' },
          initialHide: !this.showNonUsdRatioInput
        },
        { headerName: this.$t('CargoMsg.Cargo_NonUsdProfitColumn') + '-' + this.localCurrency, colId: 'nonUsdProfitCol', field: 'nonUsdProfitCol', initialWidth: 150, minWidth: 150, sortable: false, editable: false,
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          },
          cellStyle: { textAlign: 'center' },
          initialHide: !this.showNonUsdRatioInput
        },
        { headerName: this.$t('CargoMsg.Cargo_CreatedDate'), colId: 'dateCreated', field: 'dateCreated', initialWidth: 120, minWidth: 120, sortable: false, editable: false,
          valueFormatter: params => {
            return ColumnUtils.dateMinutesLabelFunc(params.value)
          }
        }
      ]
    },
    columnDefsAdjust() {
      return [
        { headerName: this.$t('CargoMsg.Cargo_SerialNo'), colId: 'serialNo', field: 'serialNo', initialWidth: 50, minWidth: 50, sortable: false, editable: false,
          cellStyle: { textAlign: 'center' }
        },
        { headerName: this.$t('CargoMsg.Cargo_ShareBranchId'), colId: 'branchId', field: 'branchId', initialWidth: 160, minWidth: 160, sortable: false, editable: false,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office_All, 'officeId', Number(params.value), 'chineseName')
          }
        },
        { headerName: (this.showNonUsdRatioInput ? this.$t('CargoMsg.Cargo_UsdRatioColumn') : this.$t('CargoMsg.Cargo_UsdRatio')) + '-%', colId: 'usdRatio', field: 'usdRatio', initialWidth: 140, minWidth: 140, sortable: false, editable: true,
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0')
          },
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 0,
              max: 100,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          onCellValueChanged: p => this.onCellChange(p),
          cellStyle: { textAlign: 'center' }
        },
        { headerName: (this.showNonUsdRatioInput ? this.$t('CargoMsg.Cargo_UsdProfitAdjustColumn') + '-USD' : this.$t('CargoMsg.Cargo_UsdProfitAdjustColumn2') + '-' + this.localCurrency), colId: 'usdProfitAdjustCol', field: 'usdProfitAdjustCol', initialWidth: 140, minWidth: 140, sortable: false, editable: false,
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          },
          cellStyle: { textAlign: 'center' }
        },
        { headerName: this.$t('CargoMsg.Cargo_NonUsdRatioColumn') + '-%', colId: 'nonUsdRatio', field: 'nonUsdRatio', initialWidth: 140, minWidth: 140, sortable: false, editable: true,
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0')
          },
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              precision: 0,
              max: 100,
              min: 0,
              controlsPosition: 'right',
              style: 'width: 100%'
            }
          },
          onCellValueChanged: p => this.onCellChange(p),
          cellStyle: { textAlign: 'center' },
          initialHide: !this.showNonUsdRatioInput
        },
        { headerName: this.$t('CargoMsg.Cargo_NonUsdProfitAdjustColumn') + '-' + this.localCurrency, colId: 'nonUsdProfitAdjustCol', field: 'nonUsdProfitAdjustCol', initialWidth: 150, minWidth: 150, sortable: false, editable: false,
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          },
          cellStyle: { textAlign: 'center' },
          initialHide: !this.showNonUsdRatioInput
        }
      ]
    },
    localCurrency() {
      return this.initShareAmount.currency || 'RMB'
    }
  },
  watch: {
    visible: {
      immediate: true,
      async handler(newVal) {
        this.innerVisible = newVal
        if (newVal) {
          this.$nextTick(() => {
            this.changeShareAmount()
          })
        }
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    onConfirm() {
      this.changeShareAmount()
      let usdRatioSum = 0
      let nonUsdRatioSum = 0
      // 分润模式
      for (const item of this.shareBranchList) {
        item.usdProfit = this.shareAmount.usdProfitAdjust
        item.nonUsdProfit = this.shareAmount.nonUsdProfitAdjust
        item.jobProfit = this.shareAmount.jobProfitAdjust
        item.currency = this.initShareAmount.currency
        item.apMaxSerialNumber = this.initShareAmount.apMaxSerialNumber
        item.officeId = this.initShareAmount.officeId
        item.usdRate = this.initShareAmount.usdRate
        item.businessDate = this.initShareAmount.businessDate
        // 比例合计
        usdRatioSum += NumberUtils.ToFixed(item.usdRatio, 0)
        usdRatioSum = NumberUtils.ToFixed(usdRatioSum, 0)
        nonUsdRatioSum += NumberUtils.ToFixed(item.nonUsdRatio, 0)
        nonUsdRatioSum = NumberUtils.ToFixed(nonUsdRatioSum, 0)
      }
      console.log('usdRatioSum', usdRatioSum)
      console.log('nonUsdRatioSum', nonUsdRatioSum)
      if (usdRatioSum > 100 || nonUsdRatioSum > 100) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ProfitShareRatioSumExceed'))
        return
      }
      // 分润历史序号
      const shareBranchs = lodash.cloneDeep(this.shareBranchList)
      const maxNo = this.shareAmounts ? this.shareAmounts.length : 0
      for (const item of shareBranchs) {
        item.serialNo = Number(item.serialNo) + maxNo
      }
      this.$emit('confirm', shareBranchs)
    },
    onCancel() {
      this.innerVisible = false
    },
    onCellChange(params) {
      if (params.colDef.field === 'usdRatio') {
        params.data.usdRatio = params.data.usdRatio || 0
        if (params.data.usdRatio < 0) {
          params.data.usdRatio = 0
        }
        if (params.data.usdRatio > 100) {
          params.data.usdRatio = 100
        }
        const usdRatio = NumberUtils.ToFixed(params.data.usdRatio / 100, 2)
        params.node.setDataValue('usdProfitAdjustCol', NumberUtils.ToFixed((this.showNonUsdRatioInput ? this.shareAmount.usdProfitAdjust : this.shareAmount.jobProfitAdjust) * usdRatio, 2))
      } else if (params.colDef.field === 'nonUsdRatio') {
        params.data.nonUsdRatio = params.data.nonUsdRatio || 0
        if (params.data.nonUsdRatio < 0) {
          params.data.nonUsdRatio = 0
        }
        if (params.data.nonUsdRatio > 100) {
          params.data.nonUsdRatio = 100
        }
        const nonUsdRatio = NumberUtils.ToFixed(params.data.nonUsdRatio / 100, 2)
        params.node.setDataValue('nonUsdProfitAdjustCol', NumberUtils.ToFixed(this.shareAmount.nonUsdProfitAdjust * nonUsdRatio, 2))
      }
    },
    changeShareAmount() {
      for (const item of this.shareBranchList) {
        item.usdRatio = item.usdRatio || 0
        const usdRatio = NumberUtils.ToFixed(item.usdRatio / 100, 2)
        item.usdProfitAdjustCol = NumberUtils.ToFixed((this.showNonUsdRatioInput ? this.shareAmount.usdProfitAdjust : this.shareAmount.jobProfitAdjust) * usdRatio, 2)
        // 非美金
        if (this.showNonUsdRatioInput) {
          item.nonUsdRatio = item.nonUsdRatio || 0
          const nonUsdRatio = NumberUtils.ToFixed(item.nonUsdRatio / 100, 2)
          item.nonUsdProfitAdjustCol = NumberUtils.ToFixed(this.shareAmount.nonUsdProfitAdjust * nonUsdRatio, 2)
        } else {
          item.nonUsdRatio = 0
          item.nonUsdProfitAdjustCol = 0
        }
      }
      this.gridApiJob.refreshCells({ force: true })
    }
  }
}
</script>

<style lang="scss">
.profit-share-dialog {
  .el-dialog__body {
    padding: 5px !important;
    .el-form-item {
      margin-bottom: 0!important;
    }
  }
}
</style>
